"use client";

import { CssBaseline, ThemeProvider } from "@bpipartners/webui";
import { getTheme } from "@cbex/utils/theme";
import { ErrorBoundary } from "react-error-boundary";
import { FallbackErrorComponent } from "@cbex/ui/fallback";
import { WebuiClientWrapper } from "./_useWcWebuiWrapper";
import React from "react";

export const ClientProviders = ({
  children,
  appName,
}: {
  children?: any;
  appName: string;
}) => (
  <ThemeProvider theme={getTheme(appName)}>
    <ErrorBoundary FallbackComponent={FallbackErrorComponent}>
      <CssBaseline />
      <WebuiClientWrapper>{children}</WebuiClientWrapper>
    </ErrorBoundary>
  </ThemeProvider>
);
